import React from 'react';
import { ServiceRequestFormData } from '../../types';

interface Props {
  formData: ServiceRequestFormData;
  updateFormData: (data: Partial<ServiceRequestFormData>) => void;
  termsLink: string | null | undefined;
  orgName: string;
  errors: { consent?: string; mobilePhone?: string };
}

/** Terms checkbox + optional SMS consent with the TCPA disclosure. Shared by the public form and the QR hub. */
const ConsentBlock: React.FC<Props> = ({ formData, updateFormData, termsLink, orgName, errors }) => (
  <>
    <div className="form-group">
      <div className="checkbox-option">
        <input type="checkbox" id="consentGiven" name="consentGiven" checked={formData.consentGiven || false}
          onChange={(e) => updateFormData({ consentGiven: e.target.checked })} />
        <label htmlFor="consentGiven">
          I have read and agree to the {termsLink ? (
            <a href={termsLink} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
          ) : (<span>Terms and Conditions</span>)}.
        </label>
      </div>
      {errors.consent && <span className="error-text">{errors.consent}</span>}
    </div>

    <div className="sms-consent-section">
      <div className="form-group">
        <div className="checkbox-option">
          <input type="checkbox" id="smsConsent" name="smsConsent" checked={formData.smsConsent || false}
            onChange={(e) => updateFormData(e.target.checked ? { smsConsent: true } : { smsConsent: false, mobilePhone: '' })} />
          <label htmlFor="smsConsent">
            I'd like to receive SMS updates about my service
            <span className="sms-disclosure">
              I consent to receive automated SMS messages from <strong>{orgName}</strong> (powered by Opervia) regarding my service request, including service status updates, appointment reminders, and service completion alerts. Message frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help. <a href="https://opervia.com/sms-terms" target="_blank" rel="noopener noreferrer">SMS Terms</a> | <a href="https://opervia.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </span>
          </label>
        </div>
      </div>
      {formData.smsConsent && (
        <div className="form-group sms-phone-input">
          <label htmlFor="mobilePhone" className="required">Mobile Phone Number</label>
          <input type="tel" id="mobilePhone" name="mobilePhone" value={formData.mobilePhone || ''}
            onChange={(e) => updateFormData({ mobilePhone: e.target.value })} placeholder="(555) 123-4567"
            className={errors.mobilePhone ? 'is-invalid' : ''} />
          {errors.mobilePhone && <span className="error-text">{errors.mobilePhone}</span>}
        </div>
      )}
    </div>
  </>
);

export default ConsentBlock;
